import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileDown } from "lucide-react";
import api, { downloadDoc, apiErr } from "@/lib/api";
import { Loading } from "@/components/site/ui";
import { SIGNATURE } from "@/constants/media";

export default function PortalCard() {
  const [card, setCard] = useState(null);
  useEffect(() => { api.get("/portal/membership-card").then((r) => setCard(r.data)).catch(() => setCard(false)); }, []);
  if (card === null) return <Loading />;
  if (!card) return <p className="text-muted-foreground">Card unavailable.</p>;
  return (
    <div className="max-w-md">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-serif text-2xl">Digital Membership Card</h2>
        <button onClick={async () => { try { await downloadDoc("/portal/documents/membership-card", `membership-${card.member_number}.pdf`); } catch (e) { toast.error(apiErr(e)); } }} className="btn-ghost-gold px-4 py-2 text-sm flex items-center gap-2" data-testid="card-download-pdf"><FileDown size={15} /> Download PDF</button>
      </div>
      <div className="rounded-2xl p-8 relative overflow-hidden glass" style={{ background: "#05070d", borderColor: `${card.color}77` }} data-testid="membership-card">
        <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full blur-3xl opacity-40" style={{ background: card.color }} />
        <div className="relative z-10">
          <img src="/assets/d-logo.png" alt="The D" className="h-16 w-16 object-contain mb-2" data-testid="card-logo" />
          <p className="text-[10px] tracking-label uppercase text-muted-foreground">The D — Private Resort &amp; Social House</p>
          <div className="gold-line my-6" />
          <p className="text-[10px] tracking-label uppercase text-muted-foreground">Member</p>
          <p className="font-serif text-3xl mt-1">{card.member_name}</p>
          <div className="flex justify-between items-end mt-8">
            <div>
              <p className="text-sm" style={{ color: card.color }}>{card.level}</p>
              <p className="text-xs text-muted-foreground mt-1">No. {card.member_number}</p>
              <p className="text-xs text-muted-foreground">Status: {card.status}</p>
              {card.valid_through && <p className="text-xs text-muted-foreground">Valid through {card.valid_through}</p>}
            </div>
            <img src={card.qr} alt="member qr" className="h-24 w-24 rounded-lg" />
          </div>
        </div>
      </div>
      <p className="text-center font-serif italic text-gold mt-8">{SIGNATURE}</p>
    </div>
  );
}
